import { useParams } from 'react-router';
import { LinkUnavailablePage } from './LinkUnavailablePage';
import { RedirectToServiceRequest } from './RedirectToServiceRequest';

export function OldPayRedirect() {
  const { token } = useParams<{ token: string }>();
  if (!token) {
    return <LinkUnavailablePage />;
  }
  // Preserve ?payment=success when Stripe redirects back from checkout — the
  // unified link's invoice step polls and verifies based on it.
  return <RedirectToServiceRequest kind="invoice" token={token} preserveSearch />;
}
